import React, { useState } from 'react';
import SwiperCore, { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';

import { Testimonial } from '../../interfaces/testimonial.types';
import { IconWithTwoCircles } from '../../uiComponents/iconWithTwoCircles/iconWithTwoCircles.component';

import {
  Container,
  ArrowContainer,
  LeftArrow,
  RightArrow,
  Content,
  Author,
  AuthorAddress,
  AuthorContainer,
  TestimonialElem,
  QuotationIcon,
} from './testimonialsSlider.styled';
import { TestimonialsSliderData } from './testimonialsSlider.types';

export const TestimonialsSlider: React.FC<TestimonialsSliderData> = (data: TestimonialsSliderData) => {
  const { testimonials, backgroundColor, circlesBackgroundColor, currentLanguage } = data;
  const [controlledSwiper, setControlledSwiper] = useState(null);
  const filteredTestimonials = testimonials.filter((testimonial: Testimonial) => testimonial.language.slug === currentLanguage);

  const renderTestimonials = () => filteredTestimonials.map((testimonial: Testimonial) =>
    <SwiperSlide key={testimonial.acf.content}>
      <TestimonialElem key={testimonial.acf.content}>
        <IconWithTwoCircles circleBackgroundColor={circlesBackgroundColor}>
          <QuotationIcon />
        </IconWithTwoCircles>
        <Content>{testimonial.acf.content}</Content>
        <AuthorContainer>
          <Author>{testimonial.acf.author}</Author>
          <AuthorAddress>{testimonial.acf.authorAddress}</AuthorAddress>
        </AuthorContainer>
      </TestimonialElem>
    </SwiperSlide>
  );
 
  const goNext = () => {
    if (controlledSwiper) {
      controlledSwiper.slideNext();
    }
  };
 
  const goPrev = () => {
    if (controlledSwiper) {
      controlledSwiper.slidePrev();
    }
  };

  SwiperCore.use([Autoplay]);

  return (
    <Container backgroundColor={backgroundColor}>
      <ArrowContainer onClick={goPrev} backgroundColor={circlesBackgroundColor}>
        <LeftArrow />
      </ArrowContainer>
      <Swiper
        loop
        autoplay={{
          delay: 5000,
          waitForTransition: false,
          disableOnInteraction: false,
        }}
        slidesPerView={1}
        onSwiper={setControlledSwiper}
      >
        {renderTestimonials()}
      </Swiper>
      <ArrowContainer onClick={goNext} backgroundColor={circlesBackgroundColor}>
        <RightArrow />
      </ArrowContainer>
    </Container>
  );
};
